export default {"src":"/_next/static/media/trueLogoLoan.26ee208c.svg","height":20,"width":20};